import component from './ModalConfirm';

export default component;
